import type ModalConversationService from '../../commons/conversation/modal-conversation.service';
import type SettingsDataService from './settings.data-service';
import type {TransferableSettingsValue, ViewableSettingChain} from 'typings/portaro.be.types';
import type FinishedResponseInteractionService from '../../commons/services/finished-response-interaction.service';


export class SettingsService {
    public static serviceName = 'settingsService';

    /*@ngInject*/
    constructor(private settingsDataService: SettingsDataService, private modalConversationService: ModalConversationService, private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async setSettings(settingTypeIds = [] as string[], message = '') {
        try {
            const settings = await this.settingsDataService.getSettingsByIds(settingTypeIds);
            await this.modalConversationService.settingsModal({settings, message});
        } catch (exceptionResponse) {
            this.finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
            throw exceptionResponse;
        }
    }

    public async getSettingsByIds(settingIds = [] as string[]): Promise<ViewableSettingChain[]> {
        try {
            return await this.settingsDataService.getSettingsByIds(settingIds);
        } catch (exceptionResponse) {
            this.finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
            throw exceptionResponse;
        }
    }

    public async getSettings(sectionId: string): Promise<ViewableSettingChain[]> {
        try {
            return await this.settingsDataService.getSettings(sectionId);
        } catch (exceptionResponse) {
            this.finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
            throw exceptionResponse;
        }
    }

    public async saveSettings(transferableSettings: TransferableSettingsValue): Promise<ViewableSettingChain> {
        try {
            const result = await this.settingsDataService.saveSettings(transferableSettings);
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(result);
            return result.savedObject;
        } catch (exceptionResponse) {
            this.finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
            throw exceptionResponse;
        }
    }

    public async deleteSettings(settingsId: string): Promise<ViewableSettingChain> {
        try {
            const result = await this.settingsDataService.deleteSettings(settingsId);
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(result);
            return result.savedObject;
        } catch (exceptionResponse) {
            this.finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
            throw exceptionResponse;
        }

    }
}